<mat-card>
    <mat-card-header>
      <mat-card-title>Password Recovery Request</mat-card-title>
    </mat-card-header>
    <mat-card-content>
  
      <div class="d-flex justify-content-center" *ngIf="submitting">
        <mat-spinner></mat-spinner>
      </div>
  
      <div *ngIf="!submitting" class="m-t-1">

        <form [formGroup]="forgotForm" *ngIf="!submitSuccess && !errorOnSubmit">
          <mat-form-field>
            <mat-label>Username</mat-label>
            <input matInput formControlName="username" type="text" [disabled]="submitSuccess" autocomplete="username"/>
            <mat-error *ngIf="forgotForm.controls.username.errors?.['required']">Username is required</mat-error>
          </mat-form-field>
 
          <div class="d-flex form-item m-t-1">
            <button class="flex-1" mat-flat-button (click)="forgot()" [disabled]="submitSuccess">Reset Password</button>
          </div>
        </form>

        <div *ngIf="submitSuccess">
            <p class="d-flex justify-content-center">If an account matches that username, you should receive an email shortly at your registered email address with instructions on how to reset your password.</p>
            <div class="d-flex justify-content-center"><a routerLink="/login" class="link-button">Return to login</a></div>    
        </div>
        <div *ngIf="errorOnSubmit">
            <p class="d-flex justify-content-center">An error occured while sending your password reset email, please try again later</p>
            <div class="d-flex justify-content-center"><a routerLink="/login" class="link-button">Return to login</a></div>    
        </div>
      </div>
    </mat-card-content>
  </mat-card>
  